import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, Layout, Menu, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';

const { Header, Content, Footer } = Layout;

const MainLayout = ({ children }) => {
  const { user, logout } = useContext(LoginContext);
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Verificar si el usuario está autenticado
    if (!user) {
      navigate('/login'); // Redirige al login si no hay usuario
    }

    // Detectar si la pantalla es pequeña (ejemplo: max-width 768px)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Cambia según el ancho deseado
    };

    // Agregar el listener para el resize
    window.addEventListener('resize', handleResize);
    handleResize(); // Ejecutar inicialmente

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [user, navigate]);

  // Menú para administradores
  const adminMenuItems = [
    { key: '1', label: <Link to="/">Inicio</Link> },
    {
      key: 'sub2',
      label: 'Posiciones',
      children: [
        { key: '2', label: <Link to="/posiciones">Por Posiciones</Link> },
        { key: '12', label: <Link to="/posicionesarticulo">Por Artículo</Link> },
      ],
    },
    {
      key: 'sub1',
      label: 'Artículos',
      children: [
        { key: '3', label: <Link to="/articulos">Artículos</Link> },
        { key: '4', label: <Link to="/marcas">Marcas</Link> },
        { key: '5', label: <Link to="/categorias">Categorías</Link> },
      ],
    },
    { key: '7', label: <Link to="/entradaxarticulo">Ingreso</Link> },
    { key: '8', label: <Link to="/salida">Salida</Link> },
    { key: '9', label: <Link to="/pedidos">Pedidos</Link> },
    { key: '10', label: <Link to="/historial">Historial</Link> },
    { key: '11', label: <Link to="/usuarios">Usuarios</Link> },
    {
      key: '12',
      label: <span onClick={logout}>Cerrar sesión</span>,
    },
  ];

  // Menú para clientes
  const clientMenuItems = [
    { key: '1', label: <Link to="/home-cliente">Inicio</Link> },
    { key: '2', label: <Link to="/posicion-cliente">Mis Posiciones</Link> },
    { key: '3', label: <Link to="/retiro-cliente">Solicitud de retiro</Link> },
    { key: '4', label: <Link to="/pedidos-cliente">Mis pedidos</Link> },
    { key: '5', label: <Link to="/historial-cliente">Historial</Link> },
    {
      key: '11',
      label: <span onClick={logout}>Cerrar sesión</span>,
    },
  ];

  // Seleccionar el menú según el tipo de usuario
  const menuItems = user?.user?.tipoUsuario === 'administrador' ? adminMenuItems : clientMenuItems;

  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#001529',
        }}
      >
        {/* Botón de menú para pantallas pequeñas */}
        {isMobile ? (
          <Button
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
            style={{
              color: '#fff',
              backgroundColor: 'transparent',
              border: 'none',
              fontSize: '20px',
            }}
          />
        ) : (
          // Menú horizontal para pantallas grandes
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={['1']}
            items={menuItems}
            style={{ flex: 1 }}
          />
        )}
      </Header>

      {/* Menú desplegable para pantallas pequeñas */}
      <Drawer
        title="Menú"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <Menu
          mode="vertical"
          defaultSelectedKeys={['1']}
          items={menuItems.map(item => ({
            ...item,
            label: (
              <span onClick={() => setDrawerVisible(false)}>
                {item.label}
              </span>
            ),
            children: item.children
              ? item.children.map(child => ({
                ...child,
                label: (
                  <span onClick={() => setDrawerVisible(false)}>
                    {child.label}
                  </span>
                ),
              }))
              : undefined,
          }))}
        />
      </Drawer>


      <Content
        style={{
          flex: 1,
          padding: '16px',
        }}
      >
        <Breadcrumb style={{ margin: '16px 0' }} />
        <div
          style={{
            padding: 24,
            minHeight: 380,
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {children}
        </div>
      </Content>

      <Footer
        style={{
          textAlign: 'center',
          padding: '12px 24px',
        }}
      >
        ©{new Date().getFullYear()} Created by Geno Software
      </Footer>
    </Layout>
  );
};

export default MainLayout;